module.exports = __webpack_public_path__ + "static/toggl-track-team-tracking-5a6e310ac73a417322e6b5e6776fa2ab.jpg";